module.exports = __webpack_public_path__ + "img/lv19.e1ef1465.png";